import { request } from "@/api/client";

export type EventSettlement = {
  performance_income: number | string;
  merch_gross: number | string;
  cogs: number | string;
  expenses: number | string;
  profit: number | string;
  merch_margin?: number | null;
  profit_per_mile?: number | null;
  computed_at: string;
};

export type EventSettlementSummary = {
  event_id: string;
  name?: string | null;
  date: string;
  city?: string | null;
  state?: string | null;
  profit: number | string;
  revenue: number | string;
  expenses: number | string;
};

export type EventSettlementFilters = {
  start?: string;
  end?: string;
};

export function fetchEventSettlement(eventId: string): Promise<EventSettlement> {
  return request(`/events/${encodeURIComponent(eventId)}/settlement`);
}

export function rollupEventSettlement(eventId: string): Promise<EventSettlement> {
  return request(`/events/${encodeURIComponent(eventId)}/rollup`, { method: "POST" });
}

export function listEventSettlements(filters: EventSettlementFilters = {}): Promise<EventSettlementSummary[]> {
  const params = new URLSearchParams();
  if (filters.start) params.set("start", filters.start);
  if (filters.end) params.set("end", filters.end);
  const suffix = params.toString();
  return request<EventSettlementSummary[]>(`/reports/events/profitability${suffix ? `?${suffix}` : ""}`).then(
    (payload) => payload ?? [],
  );
}
